import _ from 'lodash';

export default class ShopInfo {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.shopId = _.get(data, 'shopId', '');
    this.countOrder = _.get(data, 'countOrder', '');
    this.contactPoint = _.get(data, 'contactPoint', '');
  }
}
